import type { ListAttractionsParams, RankScopeType } from '~/types/attractionTypes';

export function detectActiveScope(
  filters: ListAttractionsParams,
): { scopeType: RankScopeType; scopeValue: string } | null {
  if (filters.city) return { scopeType: 'city', scopeValue: filters.city };
  if (filters.province) return { scopeType: 'province', scopeValue: filters.province };
  if (filters.state) return { scopeType: 'state', scopeValue: filters.state };
  if (filters.countryCode) return { scopeType: 'country', scopeValue: filters.countryCode };
  if (filters.country) return { scopeType: 'country', scopeValue: filters.country };
  return null;
}

/**
 * Pure function: compute the next pendingRanks after a drag-and-drop onto a ranked slot.
 *
 * @param activeId   - attraction ID being dragged
 * @param targetRank - numeric rank of the slot it was dropped onto
 * @param usedRanks  - current rank->attractionId mapping (merged from DB + pending)
 * @param prev       - current pendingRanks map
 * @returns new pendingRanks map, or the same `prev` reference when nothing changed (self-drop)
 */
export function computeSlotDrop(
  activeId: string,
  targetRank: number,
  usedRanks: Map<number, string>,
  prev: Map<string, number | null>,
): Map<string, number | null> {
  const currentHolder = usedRanks.get(targetRank);

  let activeCurrentRank: number | null = null;
  for (const [r, aid] of usedRanks.entries()) {
    if (aid === activeId) {
      activeCurrentRank = r;
      break;
    }
  }

  // Self-drop: item dropped back onto its own slot
  if (activeCurrentRank === targetRank) return prev;

  const next = new Map(prev);

  if (currentHolder && currentHolder !== activeId) {
    if (activeCurrentRank != null) {
      // Reorder within mini-table: swap (give displaced item our old rank)
      next.set(currentHolder, activeCurrentRank);
    } else {
      // Drop from main table onto occupied slot: displace
      next.set(currentHolder, null);
    }
  }
  next.set(activeId, targetRank);
  return next;
}
